"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_stripe_elements_1 = require("react-stripe-elements");
var ScriptProvider_1 = __importDefault(require("../Common/ScriptProvider"));
var StripeContainer = function (_a) {
    var children = _a.children, stripeKey = _a.stripeKey;
    var _b = __read(React.useState(null), 2), stripe = _b[0], setStripe = _b[1];
    return (React.createElement(ScriptProvider_1["default"], { onLoad: function () { return setStripe(window.Stripe(stripeKey)); }, source: "https://js.stripe.com/v3", sourceId: "stripe-js" },
        React.createElement(react_stripe_elements_1.StripeProvider, { stripe: stripe },
            React.createElement(react_stripe_elements_1.Elements, null, children))));
};
exports["default"] = StripeContainer;
